/**
 * A class represents the number of hours an employee is contracted to work.
 */
export class ContractHours {
  hours: number;
  startDate: string;

  /**
   * @param hours the number of hours an employee must work weekly by contract.
   * @param startDate the Monday from which contract hours takes effect.
   */
  constructor(hours: number, startDate: string) {
    this.hours = hours;
    this.startDate = startDate;
  }
}
